import { IState } from 'shared/store';

export const selectStatusBarMessage = (state: IState) => {
  return state.bestPlaceAnalytics.statusMessage;
};
